import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme/theme';
import App from './App.js';
import { Provider }  from 'react-redux';
import { configureStore } from './store.js';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/lib/integration/react'

const rootElement = document.querySelector('#root1');


const store = configureStore();
const persistor = persistStore(store)



ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
  </PersistGate>
  </Provider>,
  rootElement
);